import { Link } from "react-router-dom";
import { categoryGroups } from "@/mocks/categories";

export default function NotFound() {
  return (
    <div className="page-shell flex min-h-[70vh] flex-col items-center justify-center py-16 text-center">
      <p className="font-label text-[80px] font-semibold leading-none text-background-200 md:text-[120px]">
        404
      </p>
      <h1 className="mt-4 font-heading text-2xl font-semibold text-foreground-950">
        这个页面好像走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址可能已经调整或不存在。回到首页，或者从下面的频道重新开始浏览。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        {categoryGroups.map((group) => (
          <Link
            key={group.type}
            to={`/category/${group.type}`}
            className="whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-400"
          >
            {group.name}频道
          </Link>
        ))}
      </div>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
      >
        返回首页
        <i className="ri-arrow-right-line text-base" />
      </Link>
    </div>
  );
}